import { createApi } from "@reduxjs/toolkit/query/react";
import { ENDPOINTS } from "config/constant/endpoints.config";
import { Paginator } from "types/interfaces";
import { injectParamsPaginator } from "utils/helpers/api-url";
import { baseQueryWithReauth } from "../rtkBaseQuery";

export const statisticsOrderApi = createApi({
  reducerPath: "statisticsOrderApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["StatisticOrder"],
  endpoints: (builder) => ({
    getOrderStatistics: builder.mutation({
      query: ({
        start_date,
        end_date
      }: {start_date?:number,end_date?:number}) => ({
        url: `/stats/orders`,
        method: "POST",
        body: start_date && end_date? {  start_date,
            end_date
           }:{},
      }),
      invalidatesTags: ["StatisticOrder"],
    }),
  })
  
})

export const { useGetOrderStatisticsMutation} =statisticsOrderApi;
